import { ChangeDetectionStrategy, Component, OnDestroy } from "@angular/core";
import { AUTOCOMPLETE_VALUE_ACCESSOR } from "@bfx/primeng/autocomplete";
import { ICellEditorParams } from "ag-grid-community";
import { Subject, Subscription } from "rxjs";
import { BM_MULTI_ALLOCATION_COL_VALUE_DATE } from "../../order-entry/interface/oe-panel-bmark-allocation-grid.constants";
import { DfAutoComplete } from "./DfAutoComplete";
import { AUTOCOMPLETE_VIEW_PROVIDERS } from "../../bfx-element-library/bfx-autocomplete.component";

@Component({
  selector: "tenor-df-autocomplete",
  templateUrl: "./html/DfAutoComplete.html",
  providers: [AUTOCOMPLETE_VALUE_ACCESSOR],
  viewProviders: AUTOCOMPLETE_VIEW_PROVIDERS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TenorDfAutoComplete extends DfAutoComplete implements OnDestroy {
  private params: ICellEditorParams;
  private onSelectSubscription: Subscription;

  agInit(params: ICellEditorParams): void {
    super.agInit(params);
    this.params = params;
    this.onSelectSubscription = this.onSelect.subscribe((value) => {
      if (value != null) {
        this.params.data[BM_MULTI_ALLOCATION_COL_VALUE_DATE] = null;
      }
    });

    this.tabForward = (event: KeyboardEvent) => {
      if (event.shiftKey === true) {
        return;
      }

      this.hide();
    };
  }

  ngOnDestroy(): void {
    if (this.onSelectSubscription != null) {
      this.onSelectSubscription.unsubscribe();
    }
  }
}
